import { render } from "./DesignMonogram.vue?vue&type=template&id=298c95af&scoped=true"
import script from "./DesignMonogram.vue?vue&type=script&lang=js"
export * from "./DesignMonogram.vue?vue&type=script&lang=js"

import "./DesignMonogram.vue?vue&type=style&index=0&id=298c95af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c95af"]])

export default __exports__